import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { AnnouncementMutationKeys } from '@/modules/announcement/keys'
import {
	CreateAnnouncementRequest,
	CreateAnnouncementResponse,
} from '@/modules/announcement/type'
import { createAnnouncement } from '../../services'

interface UseMutationCreateAnnouncementProps {
	payload: CreateAnnouncementRequest
}

export default function useMutationCreateAnnouncement(
	props?: UseBaseMutationOptions<
		CreateAnnouncementResponse,
		UseMutationCreateAnnouncementProps
	>,
) {
	return useMutation({
		mutationKey: [AnnouncementMutationKeys.createAnnouncement],
		mutationFn: (params) => createAnnouncement(params.payload),
		...props,
	})
}
